import { Box } from '@zillow/constellation';
import React from 'react';

// xs-md breakpoints:
// Fields and Content are full width
// Content appears above the Fields

// lg-xxl breakpoints:
// Fields have a minWidth of 240px and a maxWidth of 300px
// Content takes up the remaining space
// When the height of the Fields exceeds the viewport height, the Content will “stick” as the user scrolls down so that the results of their input are always visible

// all breakpoints:
// CalculatorLayout should not have a set width; it should always expand to fill the width of its parent
// Fields and Content have a md gap between them

var CalculatorLayout = function CalculatorLayout(_ref) {
  var fields = _ref.fields,
    content = _ref.content,
    className = _ref.className,
    sxOverride = _ref.sxOverride;
  return /*#__PURE__*/React.createElement(Box, {
    className: className,
    sx: Object.assign({
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '$spacing.md',
      '@media $lg': {
        flexDirection: 'row'
      }
    }, sxOverride)
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      '@media $lg': {
        position: 'sticky',
        top: '0',
        alignSelf: 'flex-start',
        order: 2
      }
    }
  }, content), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      '@media $lg': {
        minWidth: '240px',
        maxWidth: '300px',
        order: 1
      }
    }
  }, fields));
};
var CalculatorLayout$1 = CalculatorLayout;

export { CalculatorLayout$1 as default };
